import { ECommBrand } from 'common/api/e-comm/models/ECommBrand';
import { Card } from 'common/api/e-comm/models/Card';
import { ProductType } from 'common/api/e-comm/models/Product';

// filterTypes = card-type filter options the card matches (membership, not re-typing).
export type CardWithBrand = Card & { brand?: ECommBrand; filterTypes: ReadonlySet<ProductType> };

export enum FilterGroup {
    brand = 'brand',
    cardType = 'cardType',
}

export interface Option {
    text: string;
    value: string;
    imageUrl?: string;
    group?: FilterGroup;
}

export interface Group {
    name: string;
    options: Option[];
}

export interface TabContent {
    isActive: boolean;
    brands?: Option[];
}

export interface SortOption extends Pick<Option, 'text' | 'value'> {}
export interface SortOptions {
    addedRecentlyOption: SortOption;
    amountDescOption: SortOption;
    amountAscOption: SortOption;
    lastViewedOption: SortOption;
    nameOption: SortOption;
}
